/* eslint-disable no-unused-vars*/
import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import OwnerReportGovermentComponents from 'components/OwnerReportGoverment/ownerReportGoverment.components';
import { HasAccess } from '@permify/react-role';
import { ErrorPage404 } from 'common/Error/error.common';

const CustomerOwnerReportGovermentPage = () => {
  return (
    <Fragment>
      <Helmet>
        <title>ดูยอดการใช้งานรัฐบาล</title>
      </Helmet>
      <HasAccess roles={['Masteradmin']} renderAuthFailed={<ErrorPage404 />}>
        <OwnerReportGovermentComponents />
      </HasAccess>
    </Fragment>
  );
};

export default CustomerOwnerReportGovermentPage;
